import project1 from "./images/hostinger.png";
import project2 from "./images/adventureclues.png";
import project3 from "./images/data.worldbank.org.png";
import project4 from "./images/fao.org.png";
import project5 from "./images/firstrade.png";
import project6 from "./images/hsbc.png";
import project7 from "./images/matsuyama.co.png";
import project8 from "./images/tradingeconomics.com.png";
import project9 from "./images/us.betway.png";
import project10 from "./images/vaave.png";
import project11 from "./images/worklete.png";
import project12 from "./images/webullcorp.png";
import project13 from "./images/loveawake.png";
import project14 from "./images/sofi.png";
import project15 from "./images/pokerrankings.eu.png";

import angular from "./images/angular.png";
import cogito from "./images/logos/cogito.png";
import nttdata from "./images/logos/nttdata.png";
import cybereason from "./images/logos/cybereason.png";
import panasonic from "./images/logos/panasonic.png";

import css from "./images/certificates/css.jpg";
import javascript_basic from "./images/certificates/javascript_basic.jpg";
import javascript_intermediate from "./images/certificates/javascript_intermediate.jpg";
import python_basic from "./images/certificates/python_basic.jpg";
import react_basic from "./images/certificates/react_basic.jpg";
import rest_api_intermediate from "./images/certificates/rest_api_intermediate.jpg";
import software_engineer_intern from "./images/certificates/software_engineer_intern.jpg";
import sql_advanced from "./images/certificates/sql_advanced.jpg";

export const certificates = [
  {
    name: "software_engineer_intern",
    url: software_engineer_intern,
    link: "https://www.hackerrank.com/certificates/iframe/a734b43c5d3b",
  },
  {
    name: "sql_advanced",
    url: sql_advanced,
    link: "https://www.hackerrank.com/certificates/iframe/d0c28abca696",
  },
  {
    name: "javascript_intermediate",
    url: javascript_intermediate,
    link: "https://www.hackerrank.com/certificates/iframe/0b27d0f9dcbd",
  },
  {
    name: "rest_api_intermediate",
    url: rest_api_intermediate,
    link: "https://www.hackerrank.com/certificates/iframe/01022767b2e4",
  },
  {
    name: "python_basic",
    url: python_basic,
    link: "https://www.hackerrank.com/certificates/iframe/c50706157079",
  },
  {
    name: "javascript_basic",
    url: javascript_basic,
    link: "https://www.hackerrank.com/certificates/iframe/eafe6e5948c0",
  },
  {
    name: "react_basic",
    url: react_basic,
    link: "https://www.hackerrank.com/certificates/iframe/e901711efd7a",
  },
  {
    name: "css",
    url: css,
    link: "https://www.hackerrank.com/certificates/iframe/68f543b92c8d",
  },
];

export const skills = [
  { type: "JavaScript", level: 98 },
  { type: "React", level: 98 },
  { type: "Vue.js", level: 88 },
  { type: "Angular", level: 85 },
  { type: "Next.js", level: 90 },
  { type: "Express", level: 98 },
  { type: "Node.js", level: 93 },
  { type: "TypeScript", level: 95 },
  { type: "PHP", level: 98 },
  { type: "Laravel", level: 98 },
  { type: "Codeignitor", level: 98 },
  { type: "Python", level: 90 },
  { type: "Django", level: 95 },
  { type: "Flask", level: 95 },
  { type: "FastAPI", level: 80 },
  { type: "WebRTC", level: 80 },
  { type: "Firebase", level: 75 },
  { type: "MySQL", level: 95 },
  { type: "MongoDB", level: 95 },
  { type: "Wordpress", level: 80 },
  { type: "Directus", level: 85 },
  { type: "Web3.js", level: 85 },
  { type: "Solidity", level: 80 },
  { type: "Strapi", level: 70 },
  { type: "Bubble.io", level: 78 },
  { type: "Bubble.io", level: 78 },
  { type: "WebSocket", level: 95 },
  { type: "GraphQL", level: 78 },
];

export const works = [
  {
    title: "Senior Full-Stack Developer | Contract",
    subTitle: "Gravitate",
    date: "Match 2024 – October 2024",
    content:
      "Led the integration of AI solutions like GPT-3 for NLP and machine learning models for deal analysis, improving decision-making and user engagement. I migrated legacy systems to a scalable architecture and helped create intuitive dashboards with real-time features. I implemented data scraping and API integrations for accurate, real-time listings and built deal analysis calculators using Python and React.js for ROI and cash flow evaluation. Additionally, I developed agent performance analytics with a scoring system and interactive dashboard.",
    icon: angular,
    alt: "angular",
  },
  {
    title: "Senior Full-Stack Developer (AI, Blockchain & Web3) | Part-time",
    subTitle: "Prosa.ai",
    date: "September 2023 – December 2024",
    content:
      "Led the integration of AI-driven solutions (NLP, chatbots, text recognition), migrated legacy systems to microservices, collaborated on intuitive dashboards and real-time features, and implemented Web3.js and Solidity for smart contract integration, enhancing scalability, user engagement, and blockchain capabilities.",
    icon: angular,
    alt: "angular",
  },
  {
    title: "Team Leader",
    subTitle: "TechSolutions Inc.",
    date: "October 2022 – August 2023",
    content:
      "Led the migration of internal service applications to a custom tech stack (Node.js, Express.js, React, Redux), developed reusable templates, implemented CI/CD pipelines on AWS, and designed advanced user interfaces and dashboards, driving performance, scalability, and software quality improvements through TDD.",
    icon: angular,
    alt: "angular",
  },
  {
    title: "Senior Software Engineer",
    subTitle: "DevX Innovations",
    date: "April 2020 – August 2022",
    content:
      "Led the development and optimization of full-stack applications using Python, Django, Flask, React, and Next.js, improving scalability, performance, and data synchronization, while ensuring code robustness through Test-Driven Development.",
    icon: angular,
    alt: "angular",
  },
  {
    title: "Full-Stack Developer",
    subTitle: "FinTech Solutions Ltd.",
    date: "April 2019 – January 2020",
    content:
      "Engineered real-time dashboards and WebSocket-based communication features, utilizing NLP, data scraping, and advanced visualization techniques to improve team collaboration, customer engagement, and data processing efficiency.",
    icon: angular,
    alt: "angular",
  },
  {
    title: "Backend Developer",
    subTitle: "CloudTech Systems",
    date: "March 2017 – January 2019",
    content:
      "Designed and developed scalable backend systems using PHP, Laravel, and CodeIgniter, optimizing real-time communication, database performance, and API integration to enhance system reliability and user experience.",
    icon: angular,
    alt: "angular",
  },
  {
    title: "Frontend Developer",
    subTitle: "Digital Innovations",
    date: "August 2015 – January 2017",
    content:
      "Developed responsive, high-performance web pages using HTML5, CSS3, JavaScript, and Bootstrap, optimizing cross-device compatibility, front-end performance, and API integration to enhance user experience and support evolving business needs.",
    icon: angular,
    alt: "angular",
  },
];

export const projects = [
  {
    name: "Hostinger",
    description: `
    - Leading the team in designing and building the project's architecture.
    - Overseeing and guiding the development process to ensure quality and efficiency.
    - Implementing and managing DevOps workflows to streamline deployment and maintenance.
    - Coordinating tasks and ensuring alignment with project goals and deadlines..        
    `,
    image: project1,
    link: "https://hostinger.com/",
  },
  {
    name: "Adventureclues",
    description: `
    - Refactored a very large codebase based on the best practices.
    - Migrated a React project from Reflux to Redux.
    - Cleaned up the entire project based on best practices.
    - Created new custom hooks and implemented pixel-perfect Figma design.
    - Worked on updating the npm library for UI components.    
    `,
    image: project2,
    link: "https://adventureclues.com/",
  },
  {
    name: "kWorld Ban",
    description: `-Designed and developed a highly responsive Editor App leveraging Python, Django, MongoDB, and Vue.js, delivering an intuitive and seamless user experience.
    -Implemented pixel-perfect UI/UX designs, ensuring cross-platform compatibility and flawless app performance.
    -Integrated new features and functionality, adhering to best coding practices to maintain a robust and scalable application architecture.
    -Identified and resolved critical code issues, improving application stability and performance.
    -Authored comprehensive unit tests using PyTest for backend validation and Mocha/Chai for front-end components, achieving high code   coverage and reliability.
    -Refactored and enhanced reusable components (e.g., modals, tooltips, collapsible cards) by introducing dynamic properties, improving usability, modularity, and scalability across the application.       
    `,
    image: project3,
    link: "https://data.worldbank.org/",
  },
  {
    name: "FAO",
    description: `- Worked on building an admin dashboard with React, GraphQL, Apollo, and React-Material-UI.
    - Implemented pixel-perfect Figma Designs.
    - Integrated AWS services like DynamoDB, AppSync, Cognito, S3, etc.
    - Wrote GraphQL mutations/queries/subscriptions with AppSync Resolver and integrated them with Admin Dashboard.    
    `,
    image: project4,
    link: "https://fao.org/",
  },
  {
    name: "Firstrade",
    description: `-Developed a single-page application (SPA) using React, Redux, TypeScript, HTML5, CSS3, SCSS, and the OpenTok API.
      -Translated Figma designs into pixel-perfect, mobile-responsive user interfaces, ensuring a seamless experience across devices.
      -Integrated video and audio conferencing features utilizing OpenTok and WebSocket APIs, enhancing real-time communication capabilities.
      -Implemented RESTful API integrations with Axios and Redux-Thunk to manage asynchronous data fetching and state management efficiently.
    `,
    image: project5,
    link: "https://www.firstrade.com/",
  },
  {
    name: "HSBC",
    description: `- Built responsive web front-end pages and implemented mobile-friendly and pixel-perfect figma designs with React.js, Redux, HTML5, CSS3, and styled-components.
    - Delivered a marketing website with React.js, HTML5, CSS3, and styled-components.
    - Built cross-platform mobile apps for iOS and Android platforms with React Native CLI, React, Redux, Redux-Thunk, and Axios.
    - Integrated several third-party React and React Native packages such as Google Mapbox, DnD, and Stripe payment.
    - Implement messaging functionality with SendBird API and integrated FCM for push notification.
    `,
    image: project6,
    link: "https://www.hsbc.com/",
  },
  {
    name: "Matsuyama",
    description: `- Built a Webflow website using Webflow CMS, Webflow UIKit, JavaScript, jQuery, HTML, CSS, etc.
    - Implemented mobile-friendly and pixel-perfect UI based on the Figma designs
    - Implemented UI animations
    - Integrated Third-Party systems like Maketo Form, Greenhouse, etc.
    `,
    image: project7,
    link: "https://matsuyama.co/",
  },
  {
    name: "Tradingeconomics",
    description: `- Built an admin dashboard for Modzy using React.js, GraphQL, Apollo, ES6, HTML5, CSS3, SCSS, D3.js, etc.
    - Implemented pixel-perfect Invision Design
    - Implemented several complex charts for data visualization using D3.js
    - Worked on integrating GraphQL queries and mutations
    `,
    image: project8,
    link: "https://tradingeconomics.com/",
  },
  {
    name: "Betway",
    description: `
    - Implemented pixel-perfect Figma designs with Webflow CMS, Webflow UIKit, JavaScript, jQuery, HTML, CSS, etc.
    - Integrated Third-Party systems like Youtube API, Google Calendar, etc`,
    image: project9,
    link: "https://us.betway.com/",
  },
  {
    name: "Vaave",
    description: `- Migrated the existing website infrastructure to EC2 instances and optimized deployment pipelines using Jenkins for continuous integration and delivery (CI/CD).
    - Configured Nginx as a reverse proxy for improved server performance and load balancing.
    - Integrated OAuth2 authentication systems for secure access control across the website and third-party services,
    - Collaborated with a senior visual designer to update the website's UI/UX, ensuring consistency with new design guidelines while maintaining high availability and scalability.
    - Integrated third-party systems such as Marketo forms, Greenhouse job boards, and Lob API documentation, streamlining functionality for users and enhancing backend communication.`,
    image: project10,
    link: "https://vaave.com/",
  },
  {
    name: "Webullcorp",
    description: `- Built the responsive web front end using Vue.js, Laravel, Firebase, and AWS, incorporating TypeScript, HTML5, CSS3, Sass, SCSS, and modern front-end frameworks..
    - Integrated Google Maps API to enhance location-based features.
    - Implemented social engagement features like commenting, up/down voting, and collaboration tools for user interaction within the app.
    - Integrated a secure payment gateway for processing transactions.
    - Set up analytics tracking using Firebase Analytics and integrated Google Analytics for enhanced user insights and application performance monitoring.`,
    image: project11,
    link: "https://webullcorp.com/",
  },
  {
    name: "Wns",
    description: `- Built responsive and mobile-friendly web front-end pages with React.js, Redux, HTML, CSS, SASS/SCSS, etc.
    - Worked on migrating Angular to React without a massive rewrite.
    - Integrated Backend API with Redux -Saga and Axios and 3rd party systems like Greenhouse, ZenDesk, Marketo Form, etc
    - Built an iOS app with React Native, React, Redux-Thunk.
    - Designed the entire mobile application to be able to function offline for long periods of time and sync data back once in cell reception (online).
    - Integrated Unit Testing with Jest and Increased testing coverage of the existing application Cypress.
    `,
    image: project12,
    link: "https://wns.com/",
  },
  {
    name: "Love Awake",
    description: `- Implemented pixel-perfect designs with React Native UI library based on Eva Design System.
    - Refactored the existing codebase based on the best practices and focused on test-driven-development.
    - Added Firebase back-end functions with Firebase administration.
    - Implemented push notifications for both iOS and Android platforms using FCM (Firebase Cloud Messaging).`,
    image: project13,
    link: "https://loveawake.com",
  },
  {
    name: "Sofi",
    description: `- Implemented pixel-perfect designs with React Native UI library based on Eva Design System.
    - Refactored the existing codebase based on the best practices and focused on test-driven-development.
    - Added Firebase back-end functions with Firebase administration.
    - Implemented push notifications for both iOS and Android platforms using FCM (Firebase Cloud Messaging).`,
    image: project14,
    link: "https://sofi.com",
  },
  {
    name: "Poker Rankings",
    description: `-Refactored existing codebase to align with industry best practices, prioritizing clean architecture and scalability.
    -Implemented caching mechanisms with Redis to improve data retrieval speeds and minimize server load.
    -Designed and deployed optimized algorithms for processing high-volume data, reducing processing time by over 30%.
    -Integrated performance monitoring tools like New Relic and Prometheus, enabling real-time tracking and proactive resolution of bottlenecks.
    -Collaborated with front-end teams, ensuring seamless integration and faster data exchanges between the backend and Vue.js components.
`,
    image: project15,
    link: "https://pokerrankings.eu",
  },
];

export const particlesOptions = {
  particles: {
    fpsLimit: 120,
    number: {
      value: 0,
      density: {
        enable: true,
        value_area: 800,
      },
    },
    color: {
      value: "#ff0000",
      animation: {
        enable: true,
        speed: 180,
        sync: true,
      },
    },
    shape: {
      type: "circle",
      stroke: {
        width: 0,
        color: "#000000",
      },
      polygon: {
        nb_sides: 5,
      },
      image: {
        src: "https://cdn.matteobruni.it/images/particles/github.svg",
        width: 100,
        height: 100,
      },
    },
    opacity: {
      value: 0.5,
      random: false,
      anim: {
        enable: false,
        speed: 3,
        opacity_min: 0.1,
        sync: false,
      },
    },
    size: {
      value: 50,
      random: {
        enable: true,
        minimumValue: 10,
      },
      animation: {
        enable: true,
        speed: 5,
        minimumValue: 10,
        sync: true,
        startValue: "min",
        destroy: "max",
      },
    },
    links: {
      enable: false,
    },
    move: {
      enable: true,
      speed: 10,
      direction: "none",
      random: false,
      straight: false,
      outMode: "destroy",
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200,
      },
    },
  },
  interactivity: {
    detectsOn: "window",
    events: {
      onhover: {
        enable: true,
        mode: "trail",
      },
      onclick: {
        enable: true,
        mode: "push",
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 400,
        line_linked: {
          opacity: 1,
        },
      },
      bubble: {
        distance: 400,
        size: 40,
        duration: 2,
        opacity: 0.8,
        speed: 3,
      },
      repulse: {
        distance: 200,
      },
      push: {
        particles_nb: 4,
      },
      remove: {
        particles_nb: 2,
      },
      trail: {
        delay: 0.05,
        quantity: 1,
      },
    },
  },
  retina_detect: true,
  // background: {
  //     color: "#000000",
  //     image: "url('https://images.pexels.com/photos/1191710/pexels-photo-1191710.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')",
  //     position: "50% 50%",
  //     repeat: "no-repeat",
  //     size: "cover"
  // },
  // backgroundMask: {
  //   enable: true,
  //   cover: {
  //     color: "#424242",
  //   },
  // },
};
